import {
  ArrowDownUp,
  ArrowDownWideNarrow,
  ArrowUpNarrowWide
} from 'lucide-react';

import { SORT_ASCENDING } from '@/utils';
import type { SortDirection } from '@/utils/sorting/sorting.types';

type Props = {
  isSorted: boolean | undefined;
  direction: SortDirection | undefined;
  size: number;
};

export const SortIcon = (props: Props) => {
  if (!props.isSorted) return <ArrowDownUp size={props.size} />;
  if (props.direction === SORT_ASCENDING)
    return <ArrowUpNarrowWide size={props.size} />;
  return <ArrowDownWideNarrow size={props.size} />;
};
